module.exports = __webpack_public_path__ + "static/whole-sol-place-setting.54bb091e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/hero/whole-sol-place-setting.jpg
// module id = 1048
// module chunks = 213534597649335